fragment clientFields on Client {
  id
  address {
    city
    country {
      code
    }
    postalCode
    state
    streetAddress1
    streetAddress2
  }
  appointmentReminderEmailOptout
  appointmentReminderSmsOptout
  archived
  avatar {
    medium
  }
  clientCategories {
    id
    description
    name
  }
  clientSince
  clientSource {
    id
    name
  }
  creditAccount {
    id
    outstandingBalance
  }
  creditTerms {
    creditDays
    creditLimit
  }
  dateOfBirth
  email
  externalId
  firstName
  gender
  isBanned
  isWalkIn
  landLine
  lastName
  linkedClient {
    id
    mobile
    name
  }
  marketingEmailOptout
  marketingSmsOptout
  mobile
  formattedPhoneNumber
  formattedLandLine
  name
  noShowCount
  notes
  preferredStaff {
    id
    avatar {
      medium
    }
    firstName
    lastName
    name
  }
  preferredStaffId
  rawMobile
  referringClient {
    id
    avatar {
      medium
    }
    name
  }
  shouldPromptAppointmentNotes
  shouldPromptClientNotes
  treatCard {
    matrixDisabled
    serial
  }
  treatCardAccount {
    id
    points
  }
  completed
}
